export default __webpack_public_path__ + "static/image_about@2x-5d2ca1a2e8e5a96e8424b3da9b80756a.jpg";